// Must stay the first import so the nonce is set before any style is injected
import { cspNonce } from './cspNonce'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './i18n/i18n'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import { GlobalStyles } from './components'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from './app/store'
import { QueryClient, QueryClientProvider } from 'react-query'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

const container = document.getElementById('root')!
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false }
  }
})
// Emotion (used by MUI) injects <style> elements, which the CSP only allows with the nonce
const emotionCache = createCache({ key: 'css', nonce: cspNonce })
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <GlobalStyles>
            <App />
          </GlobalStyles>
        </Provider>
      </QueryClientProvider>
    </CacheProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
